export default function Footer() {
  return (
    <footer className="mx-auto flex max-w-[1120px] justify-end border-t border-slate/15 px-6 py-5 text-[11px] tracking-[.04em] text-muted sm:px-10">
      <span>© 2026 Kyle James</span>
    </footer>
  );
}
